/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}.cell-link-content[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .icon-content[_ngcontent-%COMP%]{cursor:pointer}.cell-link-content[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:underline}"];
export { styles as styles };
